import React, { useEffect, useState } from "react";
import Header from "../../Header";
import MenuBar from "../../MenuBar";
import Footer from "../../Footer";
import BoxPayGrid from "../../BoxPayGrid";
import { PspConfigUISchema } from "./pspConfigUISchema.js";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../../context/API_Client";
import BoxPayDisappearingNotification from "./BoxPayDisappearingNotification";
import ContentHeader from "../../../reusableComponents/contentHeader/ContentHeader";
import DisplaySettingsOutlinedIcon from "@mui/icons-material/DisplaySettingsOutlined";
import {
  convertIsoToGivenTimeZone,
  getCategories,
  getPaymentMethodCategories,
} from "../../utils/utils";
import { Skeleton } from "@mui/material";
import SavedPaymentMethodModal from "./SavedPaymentMethodModal.js";

import { customToast } from "../../../reusableComponents/customToaster/customToast.js";

import LoadingLogoPage from "../../loadingPage/loadingPage.js";
import { colorBrandObject } from "../../../../constants/brandings.js";

const ViewPaymentGateways = (operationPermissions) => {
  const {
    getPspConfig,
    getAllPspConfigs,
    getAllPaymentMethods,
    merchantSettings,
    getAllModalData,
    getPaymentMethod,
  } = useAuth();
  const [pspConfigs, setPspConfigs] = useState([]);
  const [loader, setLoader] = useState(true);
  const [apiError, setApiError] = useState("");
  const [allLegalEntities, setAllLegalEntities] = useState();
  const [timeZone, setTimeZone] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [toggleSavedPaymentDialog, setToggleSavedPaymentDialog] =
    useState(false);
  const [selectedPaymentCongifData, setSelectedPaymentCongifData] = useState();
  const handleAddPaymentGateway = () => {
    navigate("/config/add_payment_gateways");
  };

  useEffect(() => {
    merchantSettings(
      function (data) {
        setTimeZone(data?.timeZone);
      },
      function (errorMsg) { }
    );
    getAllModalData(
      function (data) {
        setAllLegalEntities(data);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
    getPaymentMethod(
      function (data) { },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  }, []);

  const findEntityName = (code) => {
    if (allLegalEntities["legalEntities"]) {
      for (let i = 0; i < allLegalEntities["legalEntities"]?.length; i++) {
        if (allLegalEntities["legalEntities"][i]?.code === code)
          return allLegalEntities["legalEntities"][i]?.name;
      }
    }
  };

  const updateToggleDialog = (value, data, reload) => {
    setSelectedPaymentCongifData(data);
    setToggleSavedPaymentDialog(value);
    if (reload) {
      window.location.reload();
    }
  };

  useEffect(() => {
    if (allLegalEntities) {
      getAllPspConfigs((platformPspConfigs) => {
        getAllPaymentMethods((platformPaymentMethods) => {
          getPspConfig(
            (response) => {
              setPspConfigs(
                response?.flatMap((config) => {
                  return config?.rules?.map((rule) => {
                    return {
                      ...rule,
                      legalEntityCode: config?.legalEntityCode,
                      legalEntityName: findEntityName(config?.legalEntityCode),
                      currencyCodes: rule?.currencyCodes.join(", "),
                      paymentMethods: platformPaymentMethods
                        .filter((pMethod) =>
                          rule?.paymentMethodIds.includes(pMethod?.id)
                        )
                        .map((pMethod) => pMethod?.title),
                      pspName: platformPspConfigs.find(
                        (pConfig) => pConfig?.pspCode === config?.pspCode
                      )?.title,
                      paymentCategories: getPaymentMethodCategories(
                        Array.from(new Set(rule?.paymentMethodIds)),
                        platformPaymentMethods
                      ),
                      pspPaymentCategoryDict: getPaymentMethodCategories(
                        Array.from(new Set(rule?.paymentMethodIds))?.concat(rule?.disabledPaymentMethodIds),
                        platformPaymentMethods
                      ),
                      activatedPaymentCategoryDict: getPaymentMethodCategories(
                        Array.from(new Set(rule?.paymentMethodIds)),
                        platformPaymentMethods
                      ),
                      addedDTime: convertIsoToGivenTimeZone(
                        config?.addedDTime,
                        timeZone
                      ),
                      originalConfig: config,
                    };
                  });
                })
              );
              setLoader(false);
            },
            (error) => {
              setApiError(error);
            }
          );
        });
      });
    }
  }, [allLegalEntities]);

  return (
    <>
      <div className="content-wrapper" style={{ backgroundColor: "white" }}>
        <section className="content">
          <div style={{ width: "100%" }}>
            <SavedPaymentMethodModal
              data={selectedPaymentCongifData}
              toggleDialog={toggleSavedPaymentDialog}
              updateToggleDialog={updateToggleDialog}
              operationPermissions={operationPermissions}
            />
            <ContentHeader
              firstHeading="Configured Payment Gateways"
              secondHeading="Integrate your payment gateways with our platform for enhanced transaction flexibility"
              buttonPermissions={[operationPermissions?.createPG]}
              icon={<DisplaySettingsOutlinedIcon sx={{ color: colorBrandObject.sideBarSelectedOptionBackground }} />}
              buttonText={"Add Payment Gateway"}
              buttonType="primary"
              buttonSize="md"
              buttonVariant="contained"
              buttonOnclick={() =>
                navigate("/payment_gateway_configurations/add_payment_gateways")
              }
            />
            <div style={{ marginTop: "32px", display: "flex", width: "100%", height: loader ? "50vh" : "auto", justifyContent: "center", alignItems: "center" }}>
              {loader ? (
                <LoadingLogoPage />
              ) : (
                <BoxPayGrid
                  schema={PspConfigUISchema(updateToggleDialog, operationPermissions)}
                  data={pspConfigs}
                  showCustomizeButton={false}
                />
              )}
            </div>
            {location.state !== null && location.state.message !== null && (
              <BoxPayDisappearingNotification
                message={location.state.message}
              />
            )}
          </div>
        </section>
      </div>
    </>
  );
};

export default ViewPaymentGateways;
